<template>
  <div class="testResult">
    <default-header :h2="$t('testResult.title')"/>
    <back-btn></back-btn>

    <PhoneNumberModal v-if="showPhoneNumberModal" @send="resendSms" @close="closeModal"/>

    <div class="innerContent justifyContentFlexStart">
      <div class="additionalPadding">
        <h6
            class="testResult__title mb-3"
        >{{$t('testResult.testResultOf') + " "}}{{ getActualDate() }}</h6>
        <h6
            class="testResult__title mb-3"
            v-if="checkIFShouldShowTestedByEBT()"
        >{{$t('testResult.testedByEBT')}}</h6>
        <h2 class="text-center" v-if="currentVehicle">{{$t('clientDetails.carDetails')}}</h2>
        <div class="testResult__resultRow" v-if="currentVehicle">
          <span class="testResult__resultRow__text">
            {{$t('clientDetails.car')}}
          </span> <span class="testResult__resultRow__text">
            {{currentVehicle.name }}
          </span>
        </div>
        <div class="testResult__resultRow" v-if="currentVehicle">
          <span class="testResult__resultRow__text">
            {{$t('general.plates')}}
          </span>
          <span class="testResult__resultRow__text">
            {{currentVehicle.plates}}
          </span>
        </div>
        <h2 class="text-center mt-3">{{$t('report.title')}}</h2>
        <div class="testResult__resultRow">
          <span class="testResult__resultRow__text">
            <span class="testResult__resultRow__text__greenIcon">
              <font-awesome-icon :icon="['fas', true ? 'check-circle' : 'times-circle bad']"/>
            </span>
            {{$t('testResult.rated')}}
          </span>
          <span
              class="testResult__resultRow__text"
          >{{currentTestResult.ccaRated}} {{$t('general.cca')}}</span>
        </div>
        <div class="testResult__resultRow">
          <span class="testResult__resultRow__text">
            <span :class="statusVoltage.color">
              <font-awesome-icon :icon="statusVoltage.icon"/>
            </span>
            {{$t('general.voltage')}}
          </span>
          <span class="testResult__resultRow__text">{{ currentTestResult.voltage }} V</span>
        </div>
        <div class="testResult__resultRow">
          <span class="testResult__resultRow__text">
            <span
                :class="[currentTestResult.overallDiagnosis === 0 ? 'testResult__resultRow__text__redIcon' :
               currentTestResult.overallDiagnosis === 1 ? 'yellow-icon' :  'testResult__resultRow__text__greenIcon']"
            >
              <font-awesome-icon
                  :icon="['fas',currentTestResult.overallDiagnosis === 0 ? 'times-circle' : 'check-circle']"
              />
            </span>
            {{$t('general.measured')}}
          </span>
          <span
              class="testResult__resultRow__text"
          >{{ currentTestResult.cca }} {{$t('general.cca')}}</span>
        </div>
        <div class="testResult__resultRow">
          <span class="testResult__resultRow__text">
            <span
                :class="[getTestResult(currentTestResult.temperature, config.maxTemp, config.minTemp) === 2 ? 'testResult__resultRow__text__greenIcon' : 'testResult__resultRow__text__redIcon']"
            >
              <font-awesome-icon
                  :icon="['fas', getTestResult(currentTestResult.temperature, config.maxTemp, config.minTemp) === 2 ? 'check-circle' : 'times-circle']"
              />
            </span>
            {{$t('general.temperature')}}
          </span>
          <span class="testResult__resultRow__text">{{ currentTestResult.temperature }} °C</span>
        </div>


        <CrankingAndReservedResults :currentTestResult="currentTestResult"/>

        <h2 class="text-center">{{$t('report.diagnosis')}}</h2>
        <div class="testResult__resultRow mb-4">
          <span class="testResult__resultRow__text">
            <span
                :class="[currentTestResult.overallDiagnosis === 0 ? 'testResult__resultRow__text__redIcon' :
               currentTestResult.overallDiagnosis === 1 ? 'yellow-icon' :  'testResult__resultRow__text__greenIcon'  ]"
            >
              <font-awesome-icon
                  :icon="['fas', currentTestResult.overallDiagnosis === 0 ? 'times-circle' : 'check-circle']"
              />
            </span>
            <span class="diagnosis_text">
              {{
              currentTestResult.overallDiagnosis === 0 ? $t('testResult.diagnosisBad') :
              currentTestResult.overallDiagnosis === 1 ? $t('testResult.diagnosisAverage')
              : $t('testResult.diagnosisGood')
              }}
            </span>
          </span>
        </div>
      </div>

      <div v-if="currentBatteries === null && currentVehicle">
        <preloader></preloader>
      </div>

      <div
          v-if="currentBatteries ? currentBatteries.length === 0 ? true : false : false"
          class="d-flex justify-content-center mt-2 small"
      >{{$t('testResult.noBatteryFound')}}
      </div>
      <div v-if="currentBatteries && currentBatteries.length > 0" class="mb-4 slickContainer">
        <div v-if="currentBatteries && currentBatteries.length > 1" class="slickArrows">
          <font-awesome-icon
              @click.capture="$refs.slick.prev()"
              :icon="['fas', 'angle-double-left' ]"
          />
          <font-awesome-icon
              @click.capture="$refs.slick.next()"
              :icon="['fas', 'angle-double-right' ]"
          />
        </div>
        <slick ref="slick" :options="slickOptions">
          <div class="testResult__battery" v-for="(battery, index) in currentBatteries">
            <h5 class="testResult__battery__title"></h5>
            <h5 v-if="false" class="testResult__battery__title">
              {{
              battery.title === 'good' ?
              $t('general.goodModelIs') :
              battery.title === 'best' ?
              $t('general.bestModelIs') :
              $t('general.excellentModelIs')
              }}
            </h5>
            <div
                v-if="battery.image"
                class="testResult__battery__image"
                :style="{backgroundImage: 'url(' + battery.image + ')'}"
            ></div>
            <div
                v-else
                class="testResult__battery__image"
                :style="{backgroundImage: 'url(' + require(`@/assets/battery_placeholder.png`) + ')'}"
            ></div>
            <div @click="toggleAddingToChosenBatteries(battery)" class="testResult__battery__name">
              <font-awesome-icon
                  v-if="checkIfIsInChosenBatteries(battery.id)"
                  :icon="['fas', 'check-square' ]"
              />
              <font-awesome-icon v-else :icon="['far', 'square' ]"/>
              {{ battery.brand + ' ' + battery.model + ' ' + battery.attributes.ah}}
            </div>
          </div>
        </slick>
      </div>
      <h6
          class="testResult__title mt-4"
      >{{$t('general.chosen')}} {{ chosenBatteries.length }} {{$t('testResult.out3Batteries')}}</h6>
      <div class="mt-auto additionalPadding d-flex justify-center flex-column">
        <button
            class="btn btn-primary w-100"
            :disabled="chosenBatteries.length === 0"
            @click="goToQuote"
        >{{$t('general.continue')}}
        </button>

        <button
            @click="$router.push({name: 'CatalogModels'})"
            class="btn btn-outline-primary mt-3 pr-4 pl-4 w-100 ml-auto mr-auto"
        >
          <font-awesome-icon :icon="['fas', 'list-alt']"/>
          <span class="pl-2">{{$t('general.selectFromCatalog')}}</span>
        </button>

        <button
            v-if="checkIfShouldShowSendDrivingPatterBtn()"
            class="btn btn-outline-primary mt-3 pr-4 pl-4 w-100"
            @click="sendDrivingPatternAnalyze()"
        >{{$t('testResult.sendDrivingPatternAnalyze')}}
        </button>

        <button
            @click="$router.push({name: 'Dashboard'})"
            class="btn btn-primary mt-3 mb-2 pr-4 pl-4 w-100 ml-auto mr-auto"
        >
          <span class="pl-2">{{$t('testResult.endQuote')}}</span>
        </button>
      </div>
    </div>

    <bottom-navigation/>
  </div>
</template>

<script>
  import moment from 'moment';
  import DefaultHeader from '../partials/DefaultHeader';
  import BottomNavigation from '../partials/BottomNavigation';
  import Slick from 'vue-slick';
  import {mapGetters, mapActions} from 'vuex';
  import Preloader from '../components/Preloader';
  import BackBtn from '../components/BackBtn';
  import {HTTP} from '../http';
  import PhoneNumberModal from '../components/PhoneNumberModal';
  import CrankingAndReservedResults from '../components/CrankingAndReservedResults';

  export default {
    name: 'TestResult',
    components: {
      DefaultHeader,
      BottomNavigation,
      Slick,
      Preloader,
      BackBtn,
      PhoneNumberModal,
      CrankingAndReservedResults
    },
    data() {
      return {
        showPhoneNumberModal: false,
        msg: '',
        alertType: '',
        slickOptions: {
          centerMode: true,
          centerPadding: '26%',
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplay: false,
          focusOnSelect: true,
          swipeToSlide: true,
          touchThreshold: 10
        },
        voltageStatusMap: [
          {
            min: 12.5,
            max: 1000,
            status: {
              condition: 'report.goodCondition',
              color: 'green-icon',
              icon: 'check-circle'
            }
          },
          {
            min: 12.4,
            max: 12.49,
            status: {
              condition: 'testResult.diagnosisAverage',
              color: 'yellow-icon',
              icon: 'check-circle'
            }
          },
          {
            min: 1,
            max: 12.39,
            status: {
              condition: 'report.badCondition',
              color: 'red-icon',
              icon: 'times-circle'
            }
          }
        ],
        smsStatus: {},
        lastHash: null
      }
    },
    computed: {
      ...mapGetters({
        currentVehicle: 'getCurrentVehicle',
        currentBatteries: 'getCurrentBatteries',
        currentTestResult: 'getCurrentTestResult',
        chosenBatteries: 'getChosenBatterries',
        currentClient: 'getCurrentClient',
        config: 'getConfig'
      }),
      statusVoltage: function () {
        var array = this.voltageStatusMap;
        var voltageStatus = null;
        array.forEach(item => {
          if (
            parseFloat(this.currentTestResult.voltage) >= item.min &&
            parseFloat(this.currentTestResult.voltage) <= item.max
          ) {
            voltageStatus = item.status;
          }
        });
        return voltageStatus;
      },
      batteriesForReport: function() {
        return this.currentBatteries.map(item => {
          item.manufacturer = item.brand,
          item.tecdoc_id = item.id
          return item;
        })
      }
    },
    beforeMount() {
      this.$store.dispatch('getConfigFromBackend');
    },

    mounted() {
      $('.paddingToHide').css('padding-left', '0px');
      $('.paddingToHide').css('padding-right', '0px');
      if (this.currentVehicle) {
        if (this.currentVehicle.id) {
          this.getBatteriesData(this.currentVehicle.id).then(() => {
            this.createReport({
              client_id: this.currentClient.id,
              battery_tests_result_id: this.currentTestResult.id,
              batteries: this.batteriesForReport
            });
          });
        } else {
          this.getBatteriesDataByCarDetails({
            manufacturerId: this.currentVehicle.manufacturerId,
            modelId: this.currentVehicle.modelId,
            vehicleId: this.currentVehicle.vehicleId,
            vehicleType: this.currentVehicle.vehicleType,
            clientId: this.currentClient.id
          }).then(() => {
            this.createReport({
              client_id: this.currentClient.id,
              battery_tests_result_id: this.currentTestResult.id,
              batteries: this.batteriesForReport
            });
          });
        }
      }
    },
    destroyed() {
      $('.paddingToHide').css('padding-right', '15px');
      $('.paddingToHide').css('padding-left', '15px');
    },
    methods: {
      ...mapActions([
        'getBatteriesData',
        'getBatteriesDataByCarDetails',
        'createReport'
      ]),
      getActualDate() {
        return moment().format('YYYY-MM-DD  HH:MM');
      },

      checkIfShouldShowSendDrivingPatterBtn() {
        return window.localStorage.exideVehicleType !== '3' ? true : false;
      },
      toggleShowEnterAhModal(boolean) {
        this.showEnterAhModal = boolean;
      },
      getTestResult(measured, max, min) {
        return (Number(measured) - Number(max)) * (Number(measured) - Number(min)) <= 0 ? 2 : 0;
      },

      checkSmsStatus(hash, counter) {
        HTTP.post('/api/check-sms-status', {
          'hash': hash
        }).then(response => {

          if(this.smsStatus[hash] === 'hidden') {
            return;
          }

          if(!response.data.hasOwnProperty('status') || ['failed','undelivered','pre_failed'].includes(response.data.status)) {
            this.smsStatus[hash] = 'failed';
            this.$toasted.clear();
            this.$toasted.show('Sending SMS failed. Please try again later.');
            return;
          }

          if(['delivered','received'].includes(response.data.status)) {
            this.smsStatus[hash] = 'delivered';
            this.$toasted.clear();
            this.$toasted.show('SMS delivered!', {
              className: 'success',
            });
          }

          if(counter < 20 && ['sent','accepted','queued','sending','receiving','received',null].includes(response.data.status)) {
            counter++;
            setTimeout(() => {
              this.smsStatus[hash] = 'sending';
              this.checkSmsStatus(hash, counter)
            }, 3000);
          }
        }).catch(err => {
          this.smsStatus[hash] = 'failed';
        });
      },

      sendDrivingPatternAnalyze() {
        if (!localStorage.getItem('capacity')) {
          this.$toasted.show(this.$t('testResult.youCantSendDrivingPatterAnalyze'));
          return;
        }

        let hash = null;

        this.$toasted.show('Sending SMS...', {
          duration: null,
          className: 'success',
          onComplete: () => {
            this.smsStatus[hash] = 'hidden';
          },
          action: [
            {
              text : 'Hide',
              onClick : (e, toastObject) => {
                this.smsStatus[hash] = 'hidden';
                toastObject.goAway(0);
              }
            },
          ]
        });

        HTTP.post(`/api/update-ah/${this.currentTestResult.id}`, {
          capacity: localStorage.getItem('capacity'),
          client_id: this.currentClient.id
        }).then(response => {
          hash = response.data.hash;

          if (response.data.hasOwnProperty('hash')) {
            this.smsStatus[hash] = 'sending';
            this.checkSmsStatus(hash, 1);
          }

        }).catch(err => {
          if (err && err.hasOwnProperty('response')) {
            if (err.response.data.smsError && err.response.data.smsErrorType == 'invalid_number') {
              this.$toasted.clear();
              this.showPhoneNumberModal = true;
            }
          } else {
            this.$toasted.show(this.$i18n.t('testResult.somethingWrong'));
          }
        });

      },
      resendSms(phone) {
        this.showPhoneNumberModal = false;
        HTTP.patch(`/api/clients-phone-number/${this.currentClient.id}`, {
          phone_number: phone
        })
          .then(() => {
            this.sendDrivingPatternSMS()
          })
          .catch(() => {
            this.$toasted.show(this.$i18n.t('testResult.somethingWrong'))
          });
      },
      sendDrivingPatternSMS() {
        HTTP.post('/api/driving-pattern-sms', {
          client_id: this.currentClient.id,
          result_id: this.currentTestResult.id,
        })
          .then(res => {
            if (!res.error) {

              this.$toasted.show(this.$t('testResult.drivingPatternAnalyzeWasSend'), {
                className: 'success'
              });

              this.checkSmsStatus(res.response.data.hash, 1);
            }
          })
          .catch(err => {
            if(err.response.data.errorType == 'invalid_number') {
              this.$toasted.clear();
              this.showPhoneNumberModal = true;
            } else {
              this.$toasted.show(this.$i18n.t('testResult.somethingWrong'));
            }
          });
      },
      closeModal() {
        this.showPhoneNumberModal = false;
      },
      goToQuote() {
        this.$router.push({name: 'Quote'});
      },
      checkIFShouldShowTestedByEBT() {
        const testedByEBT = localStorage.getItem('exideTestedWithTester');
        return testedByEBT ? true : false;
      },
      toggleAddingToChosenBatteries(battery) {
        const alreadyChosen = this.chosenBatteries.some(chosen => chosen.id === battery.id);
        if (!alreadyChosen) {
          if (this.chosenBatteries.length >= 3) {
            return;
          }
          this.$store.commit('addToChosenBatteries', {
            id: battery.id,
            manufacturer: battery.brand,
            model: battery.model,
            capacity: battery.attributes.ah,
            cost_separately: false,
            image: battery.image,
            service_price: 0,
            battery_price: 0,
            comment: '',
            tecdoc_id: battery.id
          });
          this.$toasted.show(this.$i18n.t('testResult.batteryAddedToQuote'), {
            className: 'success'
          });
        } else {
          this.$store.commit('removeFromChosenBatteries', battery);
        }
      },
      checkIfIsInChosenBatteries(id) {
        return this.chosenBatteries.some(chosen => chosen.id === id);
      }
    },
  };
</script>

<style scoped lang="scss">
  .red-icon {
    color: #ff0000;
  }

  .green-icon {
    color: #0dcb09;
  }

  .yellow-icon {
    color: #fe9c55;
  }

  .diagnosis_text {
    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
  }
</style>
